// extracted by mini-css-extract-plugin
export default {"not-allowed":"IndeterminateCheckbox_not-allowed__d4Zzk"};